/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var FormatItalicOutlineIcon = function FormatItalicOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47835_3208)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7.8H15.32L11.65 16.2H14.8V19H5V16.2H8.59L12.27 7.8H9.2V5H19V7.8Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47835_3208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "14",
    height: "14",
    transform: "translate(5 5)"
  }))));
};
export default FormatItalicOutlineIcon;